import gql from 'graphql-tag'

const query = gql`
query listDevices($params: ListQueryArgs) {
  listDevices(params: $params) {
    cursors {
      hasNext
      after
    }
    items {
			updateProgress
      hardwareId
      appVersion
	  appManagerVersion
      appManagerPermissions
      deviceStatus
      lastReportTime
      isTSEStillLive
    }
  }
}`

export default query
